/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_How_BadgeInputs */

const en_landing_how_badge = /** @type {(inputs: Landing_How_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How it works`)
};

const de_landing_how_badge = /** @type {(inputs: Landing_How_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So funktioniert's`)
};

const fr_landing_how_badge = /** @type {(inputs: Landing_How_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment ça marche`)
};

const es_landing_how_badge = /** @type {(inputs: Landing_How_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo funciona`)
};

const it_landing_how_badge = /** @type {(inputs: Landing_How_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come funziona`)
};

const nl_landing_how_badge = /** @type {(inputs: Landing_How_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe het werkt`)
};

const pl_landing_how_badge = /** @type {(inputs: Landing_How_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jak to działa`)
};

const fi_landing_how_badge = /** @type {(inputs: Landing_How_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Näin se toimii`)
};

const da_landing_how_badge = /** @type {(inputs: Landing_How_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sådan fungerer det`)
};

const sv_landing_how_badge = /** @type {(inputs: Landing_How_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Så funkar det`)
};

/**
* | output |
* | --- |
* | "How it works" |
*
* @param {Landing_How_BadgeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_how_badge = /** @type {((inputs?: Landing_How_BadgeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_How_BadgeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_how_badge(inputs)
	if (locale === "fr") return fr_landing_how_badge(inputs)
	if (locale === "es") return es_landing_how_badge(inputs)
	if (locale === "it") return it_landing_how_badge(inputs)
	if (locale === "nl") return nl_landing_how_badge(inputs)
	if (locale === "pl") return pl_landing_how_badge(inputs)
	if (locale === "fi") return fi_landing_how_badge(inputs)
	if (locale === "da") return da_landing_how_badge(inputs)
	if (locale === "sv") return sv_landing_how_badge(inputs)
	return en_landing_how_badge(inputs)
});